
/// <reference path="../dashboardGoals.module.ts" />
module Meevo.Plugins.DashboardGoals {

    class PrintGoalsController {
        public criteria: any = {
            averageTicket: true,
            serviceSales: true,
            retailSales: true,
            productivity: true,
            rebook: true,
            frequencyOfVisit: true,
            newClients: true,
            retention: true,
            fiveStarRating: true,
            requestRate: true,
            memberships: true,
            giftCard: true

        };

        static $inject = [
            "$filter",
            "$mdDialog",
            "$translate"
        ];

        constructor(
            protected $filter: angular.IFilterService,
            protected $mdDialog: angular.material.IDialogService,
            protected $translate: angular.translate.ITranslateService
        ) {

        }

        apply = () => {
            this.$mdDialog.hide({
                criteria: this.criteria
            });
        };

        cancel = () => {
            this.$mdDialog.hide(false);
        };
    }

    angular.module("meevo.plugins.dashboardGoals")
        .controller("meevo.plugins.dashboardGoals.PrintGoalsController", PrintGoalsController);
}